import React from 'react';

import { InputLabel, Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';

type Props = {
  value: 2 | 3;
  onChange: (val: 2 | 3) => void;
};

export default function ColumnsCountToggle({ value, onChange }: Props) {
  return (
    <Stack alignItems="flex-start">
      <InputLabel shrink>Number of columns</InputLabel>
      <ToggleButtonGroup
        exclusive
        value={value}
        fullWidth
        size="small"
        onChange={(ev, value) => {
          onChange(value);
        }}
      >
        <ToggleButton value={2}>2</ToggleButton>
        <ToggleButton value={3}>3</ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
}
